import { useReactiveVar } from '@apollo/client';
import {
  Box,
  Stack,
  Typography,
  IconButton,
  useTheme
} from '@mui/material';


import { reactiveVariables } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';



export type ActivityHeaderSectionLayoutProps = {
  title?: string;
  subtitle?: string;
  actionButtons?: ReactNode | ReactNode[];
  children?: ReactNode;
  backButton?: ReactNode;
  overideReturnPath?: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ActivityHeaderSectionLayoutProps) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const activeProjectName = useReactiveVar(reactiveVariables.activeProjectName);
  return (
    <Box
      display='flex'
      flexDirection='column'
      rowGap='1.5rem'
    >
      <Typography>
        {activeProjectName ?? 'name'}
      </Typography>
      <Box
        display='flex'
        flexDirection='row'
        columnGap='.75rem'
      >
        {
          props.backButton && (
            <IconButton
              onClick={() => navigate(props.overideReturnPath ?? '..')}
              sx={{
                borderRadius: '.25rem',
                bgcolor: theme.palette.customGray.light
              }}
            >
              <CustomIcon.medium.FC icon='CHEVRONLEFT' />
            </IconButton>
          )
        }
        <Stack
          direction='column'
          flex='1 1 0'
          rowGap='0'
        >


          <Stack
            direction='row'
            columnGap='.75rem'
            flex='1 1 0'
            justifyContent='space-between'
          >
            {
              props.title && (

                <Typography
                  variant='activityHeader'
                  flex='1 1 0'
                >
                  {props.title}
                </Typography>
              )
            }

            {/* ACTIONS */}
            {
              props.actionButtons ?? <></>
            }
          </Stack>


          {props.subtitle && (


            <Typography
              variant='activitySubHeaderPrimary'
            >
              {props.subtitle}
            </Typography>

          )}
        </Stack>
      </Box>
      {/* METRICS */}
      {props.children && (
        props.children
      )}

    </Box>
  );
};
